import React, { Component } from 'react';
import CopyToClipboard from 'copy-to-clipboard'
import './DesignSelectPopup.scss';
import Dialog from '@material-ui/core/Dialog';
import { PurchaseButton, NormalButton, FreeCouponButton } from './DesignSelectPopup.style';
import UploadCompleted from '@/Common/UploadCompleted/UploadCompleted'
import ConfirmationDialog from '../../UserPage/Common/ConfirmationDialog/ConfirmationDialog';
import Loading from '@/Common/loading/loading';
import HeartNumber from '../../ShopAndShop/SelectDesigner/DesignerBox/HeartNumber';
import ShareDialog from '../../UserPage/MyVideo/ShareDialog/ShareDialog'
import OneBtnDialog from '../../Common/OneBtnDialog/OneBtnDialog';
import i18n from '../../i18n';
import TemplateHelper from '@/utils/TemplateHelper'
import { connect } from 'react-redux'
import { SetIsShowLoginDialog } from '../../Interface'
import { Trans } from 'react-i18next'
import DataManager from '@/utils/DataManager';
import { FetchCoupons } from "@/Interface"
import { PaymentsApis } from "@/utils/Videomonster/Apis"
import { VideoApis } from "@/utils/Videomonster/Api"
import { ErrorHandler } from '@/utils/Error/Handler'
import NewTemplateDaysDialog from '@/Common/NewTemplateDaysDialog/NewTemplateDaysDialog';
class DesignSelectPopup extends Component {
  state = {
    open: false,
    isUploadCompleted: false,
    visibleTitlePopUp: false,
    isNewTemplateAlertDialogOpen: false,
    similarVideos: undefined,
    isLoading: false,
    showMakeFreeVideoDialog: false,
    isDialogOpened: false,
    isShareDialogOpened: false,
    dialogType: "requestDesignerLogin",
    calculatedVideoTagSize: {
      width: 0,
      height: 0
    }
  };
  groupKeys = [
    { groupKey: "Title", width: 21, height: 15 },
    { groupKey: "End", width: 21, height: 15 },
    { groupKey: "9:16", width: 14, height: 20 },
    { groupKey: "1:1", width: 14, height: 14 },
    { groupKey: "16:9", width: 19, height: 14 },
    { groupKey: "4:5", width: 14, height: 18 }
  ]
  provider = DataManager.GetProvider();
  floatDivRef = null;
  resizeObserver = null;

  setFloatDivRef = ref => {
    this.floatDivRef = ref;
    if (this.floatDivRef) {
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(entries => {
          this.calculateVideoTagSize()
        })

        this.resizeObserver.observe(this.floatDivRef)
      }
      else {
        this.calculateVideoTagSize()
      }
    }
    else {
      if (this.resizeObserver instanceof window.ResizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    }
  }

  calculateVideoTagSize = () => {
    if (!this.floatDivRef) return

    this.setState({
      calculatedVideoTagSize: {
        width: this.floatDivRef.getBoundingClientRect().height,
        height: this.floatDivRef.getBoundingClientRect().height
      }
    })
  }

  renderPurchaseButton = (
    currentUser,
    selectedVideo,
    paymentMode,
    pointTicket,
    coupons,
    accountStatus,
    isNewTemplate,
  ) => {
    const provider = DataManager.GetProvider();
    const isValidCoupon = coupons ? coupons.some((item) => DataManager.IsValidCoupon(item, provider)) : false
    const isFreeUser = accountStatus && accountStatus.isExpiredFreePeriod;

    if (currentUser) {
      if (currentUser.admin || paymentMode || pointTicket) {
        return (
          <NormalButton
            onClick={this.registerVideo(selectedVideo._id, paymentMode)}
            margin="0 10px">
            <p lang={this.props.value} style={{ color: '#ffffff' }}>{i18n.t("designselectpopup.move.make.edit")}</p>
          </NormalButton>
        )
      }
      else {
        if (selectedVideo.isPremium) {
          return (
            <NormalButton
              onClick={() => window.open('/payment', '_blank')}
              margin="0 10px">
              <p lang={this.props.value} style={{ color: '#ffffff' }}>{i18n.t("designselectpopup.move.premium.purchase")}</p>
            </NormalButton>
          )
        }
        else if (isValidCoupon) {
          return (
            <NormalButton
              onClick={() => this.handleUseCoupon(selectedVideo._id)}
              margin="0 10px">
              <p lang={this.props.value} style={{ color: '#ffffff' }}>{i18n.t("designselectpopup.move.use.coupon")}</p>
            </NormalButton>
          )
        }
        else if (isFreeUser) {
          return (
            <>
              <PurchaseButton
                onClick={this.onPurchaseButtonClicked}>
                <p style={{ color: '#ffffff' }}
                  lang={this.props.value}>
                  {i18n.t("designselectpopup.move.purchase")}
                </p>
              </PurchaseButton>
              <FreeCouponButton
                onClick={() => this.showMakeFreeVideoDialog(isNewTemplate)}>
                <p lang={this.props.value} style={{ color: '#ffffff' }}>{i18n.t("designselectpopup.move.make.free.video")}</p>
              </FreeCouponButton>
            </>
          )
        }
        else {
          return (
            <NormalButton
              onClick={() => window.open('/payment', '_blank')}
              margin="0 10px">
              <p lang={this.props.value} style={{ color: '#ffffff' }}>{i18n.t("designselectpopup.move.payment")}</p>
            </NormalButton>
          )
        }
      }
    }
    else {
      return (
        <div lang={this.props.value} className="go-login-btn" onClick={this.goLogin()}>
          {i18n.t("designselectpopup.move.login")}
        </div>
      );
    }
  };

  // 계정 정지 시 편집 막는거 (false이면 정지, undefined면 아직 서버 통신 안된거)
  isLimit = () => {
    const { accountStatus } = this.props
    if (accountStatus.isEditable === undefined) {
      return 'pending'
    }
    if (accountStatus.isEditable === false) {
      return i18n.t("designselectpopup.alert.limit.edit")
    }
    else
      return 'passed'
  }

  handleNewTemplateAlertDialogClose = () => {
    this.setState({ isNewTemplateAlertDialogOpen:false });
  }

  onPurchaseButtonClicked = () => {
    const { selectedVideo } = this.props
    let isLimit = this.isLimit()
    if (isLimit === 'passed') {
      this.props.history.push({
        pathname: '/payment',
        state: { selectedTemplateId: selectedVideo._id, selectedVideo }
      });
    }
    else {
      alert(isLimit)
    }

  };

  handleUseCoupon = async (selectedVideoId) => {
    const isLimit = this.isLimit()
    const token = DataManager.GetToken()
    const { coupons } = this.props

    if(isLimit !== 'passed') return alert(isLimit)
    if (!token) return this.goLogin()

    try {
      this.setState({ isLoading: true })
      const body = {
        name: `이름은 아무거나-${selectedVideoId}`,
        template_id: selectedVideoId,
        lang: this.props.value
      };

      if (this.provider) body.provider = this.provider;

      const { result, data } = await VideoApis.PostVideoRegister(token, body);

      if (!result) {
        this.setState({ isLoading: false })
        ErrorHandler(this, null, new Error("ERR_INVALID_PARAM"), { server: false, alert: true })
        return
      }

      const productId = DataManager.GetProductId(this.provider).PRODUCT_ID
      const couponInfo = DataManager.GetCouponInfo(coupons, this.provider)
      
      const freePaymentBody = {
        productId,
        templateId: selectedVideoId,
        videoId: data._id,
        couponId: couponInfo && couponInfo._id,
      };

      if (this.provider) freePaymentBody.provider = this.provider;

      const response = await PaymentsApis.PostFreePayment(token, freePaymentBody)
      if (response.result) {
        FetchCoupons()
        this.props.history.push({
          pathname: `/makevideo`,
          search: `?id=${data && data._id}`
        });
        this.setState({ isLoading: false })
      } else {
        this.setState({ isLoading: false })
      }

    } catch (e) {
      const { currentUser } = this.props
      const userId = currentUser ? currentUser._id : null
      const errorCode = await ErrorHandler(this, userId, e, { log: true, server: true })
      alert(i18n.t("designselectpopup.alert.error.register.video"), errorCode)

      this.setState({ isLoading: false })
    }
  }

  handleCloseShowMakeFreeVideoDialog = () => { this.setState({ showMakeFreeVideoDialog: false }) }
  showMakeFreeVideoDialog = (isNewTemplate) => {
    if (isNewTemplate) return this.setState({ isNewTemplateAlertDialogOpen: true });
    const token = localStorage.getItem('token');
    if (token === undefined || token === '') {
      this.setState({
        visibleTitlePopUp: true
      });
      return;
    }
    this.setState({
      dialogType: "freevideoalert",
      showMakeFreeVideoDialog: true
    });
  }

  registerVideo = (selectedVideoId, paymentMode) => () => {
    let isLimit = this.isLimit();
    const token = localStorage.getItem('token');
    const paymentId = paymentMode ? paymentMode._id : null;
    if (isLimit === 'passed') {
      if (token === undefined || token === '') {
        this.setState({
          visibleTitlePopUp: true
        });
        return;
      }
      const body = {
        name: `이름은 아무거나-${selectedVideoId}`,
        template_id: selectedVideoId,
        paymentId,
        lang: this.props.value,
        isTemp: true,
      };

      if (this.provider) body.provider = this.provider;

      const axiosResult = VideoApis.PostVideoRegister(token, body);

      this.setState({ isLoading: true });
      axiosResult
        .then(res => {
          this.props.history.push({
            pathname: `/makevideo`,
            search: `?id=${res.data && res.data._id}`
          });
          this.setState({ isLoading: false });
        })
        .catch(error => {
          alert(i18n.t("designselectpopup.alert.error.register.video"), error);
          this.setState({ isLoading: false });
        });
    }
    else {
      alert(isLimit);
    }
  };

  handleClose = () => {
    this.setState({
      isUploadCompleted: false,
      visibleTitlePopUp: false,
      isDialogOpened: false,
      showMakeFreeVideoDialog: false
    });
  };

  closeUploadCompletedDialog = page => () => {
    if (page === 'GoToMypage') {
      this.props.history.push(
        `/user/${this.props.currentUser && this.props.currentUser.userId}`
      );
    }
  };
  goLogin = () => () => {
    SetIsShowLoginDialog(true)
  };
  closeDialogHook = () => {
    this.props.closeDialog();
    this.setState({ similarVideos: undefined });
  };

  checkWindowSize = () => {
    return window.innerWidth < 0
  }

  makeFreeVideo = (selectedVideoId) => () => () => {
    let isLimit = this.isLimit();
    const token = localStorage.getItem('token');
    if (isLimit === 'passed') {
      if (token === undefined || token === '') {
        this.setState({
          visibleTitlePopUp: true
        });
        return;
      }
      const body = {
        name: `이름은 아무거나-${selectedVideoId}`,
        template_id: selectedVideoId,
        lang: this.props.value,
        isTemp: true,
      };

      if (this.provider) body.provider = this.provider;

      const axiosResult = VideoApis.PostVideoRegister(token, body);
      this.setState({ isLoading: true });
      axiosResult
        .then(res => {
          this.props.history.push({
            pathname: `/makevideo`,
            search: `?id=${res.data && res.data._id}`
          });
          this.setState({ isLoading: false });
        })
        .catch(error => {
          alert(i18n.t("designselectpopup.alert.error.register.video"), error);
          this.setState({ isLoading: false });
        });
    } else {
      alert(isLimit);
    }
  }

  handleOpenShareDialog = () => this.setState({ isShareDialogOpened: true })
  handleCloseShareDialog = () => this.setState({ isShareDialogOpened: false })
  handleCloseAllShareDialog = () => this.setState({ isShareDialogOpened: false, isDialogOpened: false })

  clickShareItem = async method => {
    const { selectedVideo: { _id } } = this.props
    
    try {
      const shareLink = window.location.origin + `/designselect?template_id=${_id}`
      const { invokeCSharpAction } = window
      const isXamarin = invokeCSharpAction
      switch (method) {
        case 'twitter':
        case 'facebook':
          let targetLink = 'about:blank'
          if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
          else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

          if (isXamarin) window.location.href = targetLink
          else {
            const windowRef = window.open(targetLink, '_blank')
            if (!windowRef) this.setState({
              isDialogOpened: true,
              dialogType: "shareLinkBlock"
            })
          }
          break
        case 'linkxamarin':
          window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
          break

        case 'link':
        default:
          CopyToClipboard(shareLink)
          this.setState({
            isDialogOpened: true,
            dialogType: "shareSuccess"
          })
          break
      }
    }
    catch (e) {
      this.setState({
        isDialogOpened: true,
        dialogType: "shareFail"
      })
    }
  }

  renderContents = contents => {
    if (typeof contents !== 'string' || !contents) return ''
    const arr = contents.split('\n')

    return arr.map(content => <>
      {content}<br />
    </>)
  }

  //[명수] ratio Buttion Click Event 추가
  handleGroupKeyClick = groupKey => {
    const { selectedVideo, templateGroupMap } = this.props

    if (!selectedVideo) return
    if (selectedVideo.groupKey === groupKey || selectedVideo.ratio === groupKey) return
    if (!templateGroupMap || !templateGroupMap[selectedVideo.groupName] || !templateGroupMap[selectedVideo.groupName].item[groupKey]) return

    this.props.changeSelectedVideo(templateGroupMap[selectedVideo.groupName].item[groupKey]._id)
  }

  renderGroupKeyButton = () => {
    const { selectedVideo, templateGroupMap } = this.props
    if (!selectedVideo) return null

    const existsKeys = {}
    if (!templateGroupMap || !templateGroupMap[selectedVideo.groupName]) {
      existsKeys[selectedVideo.groupKey] = true
    }
    else {
      Object.keys(templateGroupMap[selectedVideo.groupName].item).forEach(groupKey => existsKeys[groupKey] = true)
    }

    let { groupKeys } = this;
    groupKeys = groupKeys.filter(item => existsKeys[item.groupKey])
    return groupKeys.map((groupKey, index) => {
      const isSelected = groupKey.groupKey === (selectedVideo.groupKey || selectedVideo.ratio)
      return (
        <div
          key={index}
          className={`design-select-video-ratio ${isSelected ? "active" : ""}`}
          style={{ width: `${(1 / groupKeys.length) * 100}%` }}
          onClick={() => this.handleGroupKeyClick(groupKey.groupKey)}>
          <div className={`ratio-ractangle ${isSelected ? "active" : ""}`} style={{ width: `${groupKey.width}px`, height: `${groupKey.height}px` }}></div>{groupKey.groupKey}
        </div>
      )
    })
  }

  renderIconList = () => {
    const { selectedVideo } = this.props;
    const lang = this.props.value;
    const contents = [
      {
        src: "https://front.videomonster.com/images-7cuytg20/web/videolengthico.gif",
        alt: "video length icon",
        text: i18n.t("designselectpopup.video.length.text"),
        value: <p>{selectedVideo.time}{lang === "en" ? <span> </span> : ``}{i18n.t("designselectpopup.video.length.second.text")}</p>
      },
      {
        src: "https://front.videomonster.com/images-7cuytg20/web/videoicon.png",
        alt: "video source image count",
        text: i18n.t("designselectpopup.need.img.text"),
        value: <p>{selectedVideo.imageCount}</p>
      },
      {
        src: "https://front.videomonster.com/images-7cuytg20/web/editableicon.png",
        alt: "editable icon",
        text: i18n.t("designselectpopup.video.editable.text"),
        value: <p>{selectedVideo.isEditableApproved ? i18n.t("designselectpopup.video.editable.y") : i18n.t("designselectpopup.video.editable.n")}</p>
      }
    ]

    return contents.map((content, index) => {
      return (
        <div className="design-select-video-icon-info" key={index}>
          <div className="design-select-video-icon">
            <img src={content.src}
              alt={content.alt} />
            <div className="design-select-video-icon-text">
              {content.text}
            </div>
          </div>
          <div className="design-select-video-icon-value">
            {content.value}
          </div>
        </div>
      )
    })
  }

  render() {
    const {
      selectedVideo,
      isDialogOpened,
      onVideoLikedButtonClicked,
      currentUser,
      likedVideos,
      paymentMode,
      pointTicket,
      coupons,
      accountStatus
    } = this.props;
    const lang = this.props.value
    if (selectedVideo === undefined) {
      return null
    }
    const contentsObj = selectedVideo.contentsObj
    const isNewTemplate = selectedVideo.isNewTemplate;
    const newTemplateRemainDays = selectedVideo.newTemplateRemainDays;
    const hashtag = selectedVideo !== undefined ? this.renderContents(contentsObj[lang]) : ''
    const isCafe24Provider = DataManager.IsProvider(DataManager.PROVIDER.CAFE24);

    return (
      <>
        <ConfirmationDialog
          onDeleteClicked={this.makeFreeVideo(selectedVideo._id)}
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("global.confirm")}
          closeDialog={this.handleCloseShowMakeFreeVideoDialog}
          isDialogOpened={this.state.showMakeFreeVideoDialog}
          title={i18n.t("designselectpopup.confirmationdialog.makefreetitle")}
          message={i18n.t("designselectpopup.confirmationdialog.makefreetext")}
        />
        <ConfirmationDialog
          onDeleteClicked={this.goLogin}
          cancleText={i18n.t("global.cancel")}
          deleteText={i18n.t("designselectpopup.confirmationdialog.deleteText3")}
          closeDialog={this.handleClose}
          isDialogOpened={this.state.visibleTitlePopUp}
          title={i18n.t("designselectpopup.confirmationdialog.title3")}
          message={i18n.t("designselectpopup.confirmationdialog.message3")}
        />
        <UploadCompleted
          DesignedButtonText={i18n.t("designselectpopup.UploadCompleted.DesignedButtonText")}
          dialogBodyText1={i18n.t("designselectpopup.UploadCompleted.dialogBodyText1")}
          dialogBodyText2={i18n.t("designselectpopup.UploadCompleted.dialogBodyText2")}
          dialogHeadText={i18n.t("global.notice")}
          open={this.state.isUploadCompleted}
          closeUploadCompletedDialog={this.closeUploadCompletedDialog}
          closeBtn={this.handleClose}
        />
        <ShareDialog
          open={this.state.isShareDialogOpened}
          onClose={this.handleCloseShareDialog}
          onShare={this.clickShareItem}
        />
        <OneBtnDialog
          open={this.state.isDialogOpened}
          dialogType={this.state.dialogType}
          closeBtn={this.handleClose}
          onButtonClick={
            this.state.dialogType === 'shareLinkBlock' ||
            this.state.dialogType === 'shareSuccess' ||
            this.state.dialogType === 'shareFail'
            ? this.handleCloseAllShareDialog : this.goLogin()
          }
          DesignedButtonText={
            this.state.dialogType === 'shareLinkBlock' ||
            this.state.dialogType === 'shareSuccess' ||
            this.state.dialogType === 'shareFail'
            ? null : i18n.t("designselectpopup.confirmationdialog.deleteText3")
          }
        />
        <Dialog
          open={isDialogOpened}
          onClose={this.closeDialogHook}
          maxWidth={false}
          fullScreen={this.checkWindowSize()}
          className="design-select-popup-dialog"
        >
        <NewTemplateDaysDialog newTemplateRemainDays={newTemplateRemainDays} open={this.state.isNewTemplateAlertDialogOpen} onClose={this.handleNewTemplateAlertDialogClose} history={this.props.history} />
          <div className="design-select-popup-contanier" >
            <div className={this.state.isLoading ? 'overlay' : ''} >
              {this.state.isLoading ? (
                <Loading componentName={i18n.t("designselectpopup.making.video")} reversal={true} />
              ) : (
                  <>
                    <div className="design-select-popup-wrap" style={{ width: this.state.calculatedVideoTagSize.width + 450 }}>
                      <div className="design-select-video-preview" style={{
                        width: this.state.calculatedVideoTagSize.width,
                        height: this.state.calculatedVideoTagSize.height
                      }}>
                        <video
                          src={TemplateHelper.getPreviewVideo(selectedVideo, lang) || ''}
                          controls
                          controlsList="nodownload"
                          autoPlay
                          style={{
                            width: this.state.calculatedVideoTagSize.width,
                            height: this.state.calculatedVideoTagSize.height
                          }}>
                          Your browser does not support the video tag.
                      </video>
                      </div>

                      <div className="float-wrap" ref={this.setFloatDivRef}>
                        <div
                          className="close-btn"
                          onClick={this.closeDialogHook}>
                          <div className="closeBar1" />
                          <div className="closeBar2" />
                        </div>
                        <div className="design-select-video-text">
                          <div className="design-select-video-title">
                            {selectedVideo !== undefined
                              ? TemplateHelper.getName(selectedVideo, lang)
                              : ''}
                          </div>
                          {hashtag && <div className="design-select-video-hashtag">{hashtag}</div>}
                          { (!selectedVideo.isPremium && isNewTemplate && !isCafe24Provider) &&
                            <div className="design-select-video-new-template">
                              <p>
                                <Trans i18nKey='designselectpopup.new.template' tOptions={{DAYS:newTemplateRemainDays}}><span/></Trans>
                              </p>
                            </div>
                          }
                          {
                            selectedVideo.isPremium &&
                            <div className='design-select-video-premium'>
                              <Trans i18nKey="designselectpopup.premium.template" ><span /></Trans>
                            </div>
                          }
                          <div className="design-select-video-text-middle">
                            <div className="copyright-content">
                              {i18n.t("designselectpopup.designed.by.text")}<span>{selectedVideo.uploaderName || "VIDEOMONSTER"}</span><br />
                              {i18n.t("designselectpopup.music.by.text")}<span>VIDEOMONSTER</span>
                            </div>

                            <div className="design-select-buttons-wrapper">
                              <img
                                className="design-select-img"
                                src="https://front.videomonster.com/images-7cuytg20/web/sharedLinkPage/shareIcon.png"
                                onClick={this.handleOpenShareDialog}
                                alt="shareIcon"
                              />
                              <HeartNumber
                                position={false}
                                left
                                onClick={currentUser ? onVideoLikedButtonClicked(selectedVideo, likedVideos) : this.goLogin()}
                                islikeHeart={Array.isArray(likedVideos) && likedVideos.findIndex(
                                  groupName => groupName === selectedVideo.groupName) !== -1} />
                            </div>
                          </div>
                          <p className="design-select-ratios-title">{i18n.t("designselectpopup.screen.ratio.text")}</p>
                          {/*[명수] 비율 버튼 추가 */}
                          <div className="design-select-video-ratios">
                            {this.renderGroupKeyButton()}
                          </div>
                          <div className="design-select-video-icon-info-wrapper">
                            {this.renderIconList()}
                          </div>
                          <div className="popup-buttons">
                            {this.renderPurchaseButton(
                              currentUser,
                              selectedVideo,
                              paymentMode,
                              pointTicket,
                              coupons,
                              accountStatus,
                              isNewTemplate
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="copyright">
                          <p>
                            ⓒ {i18n.t("designselectpopup.copyright.text")}
                          </p>
                        **{i18n.t("designselectpopup.info.text1")}<br />
                        {!isCafe24Provider && `**${i18n.t("designselectpopup.info.text3")}`}
                        </div>
                      </div>
                    </div>
                  </>
                )}
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = state => ({
  value: state.langStore.lang,
  currentUser: state.userStore.user,
  likedVideos: state.likeTemplatesStore.likeTemplates,
  paymentMode: state.paymentModeStore.paymentMode,
  pointTicket: state.pointTicketStore.pointTicket,
  accountStatus: state.accountStatusStore.accountStatus,
  coupons: state.couponStore.coupons,
})

export default connect(mapStateToProps, null)(DesignSelectPopup)